// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/RoleList/index.less
// module id = 2026
// module chunks = 0